/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LegacyOasisTrackingFormTypeViewModel } from './LegacyOasisTrackingFormTypeViewModel'; 

export function getLegacyOasisFormTrackingTypesOptions(onSuccess?: (result: LegacyOasisTrackingFormTypeViewModel[]) => void) {
	return queryOptions({
		queryKey: ['legacy-oasis-form-tracking-types'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/oasis/getlegacyoasisformtrackingtypes/';
			const resp = await axios.get<LegacyOasisTrackingFormTypeViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}